class AlmNamespace {
  constructor() {
    this.#check();
  }

  #check(): void {
    if (!window.alm) {
      window.alm = {};
    }
  }

  add(name: string, entity: unknown): void {
    this.#check();

    if (window.alm && !window.alm[name]) {
      window.alm[name] = entity;
    }
  }
}

export const almNamespace = new AlmNamespace();
